'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./common/age'));
});

